import { render, staticRenderFns } from "./BGPList.vue?vue&type=template&id=99c69908&"
import script from "./BGPList.vue?vue&type=script&lang=js&"
export * from "./BGPList.vue?vue&type=script&lang=js&"
import style0 from "./BGPList.vue?vue&type=style&index=0&id=99c69908&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports